import PropTypes from 'prop-types';
import React from 'react';
import HiddenItem from '../hiddenItem/hiddenItem';
import type { HiddenItemData } from '#packages/mobileEditor';
import { ItemShape } from '../hiddenItemsData';
import type { BiEventDefinition, BiEventFields } from 'types/bi';

interface Props {
  hiddenComps: Array<HiddenItemData>;
  pageId: string;
  title: string;
  sectionType: string;
  sendBi: (event: BiEventDefinition, parameters: BiEventFields) => void;
}

export default class extends React.Component<Props> {
  static displayName = 'hiddenItemsContainer';

  static propTypes = {
    hiddenComps: PropTypes.arrayOf(ItemShape).isRequired,
    pageId: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    sectionType: PropTypes.string.isRequired,
    sendBi: PropTypes.func,
  };

  render() {
    return (
      <div className="hidden-items-container">
        <div className="container-header">{this.props.title}</div>
        <div className="container-comps">
          {this.props.hiddenComps.map((comp) => (
            <HiddenItem
              key={comp.compId}
              {...comp}
              pageId={this.props.pageId}
              sectionType={this.props.sectionType}
              sendBi={this.props.sendBi}
            />
          ))}
        </div>
      </div>
    );
  }
}
